import { datadogLogs } from "@datadog/browser-logs";

import { types } from "./definitions";
import { gitSha, DATADOG_LOG_CLIENT_TOKEN } from "./definitions/constants";

/**
 * !IMPORTANT Logger must be initialized at the application level to properly
 * set the env and service for DD.
 */
class Logger {
  initialized: boolean;

  /**
   * Since our Logger abstracts dataDogLogs, we set DD methods to any
   * since all types will come directly from the DD package.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setUser: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setGlobalContextProperty: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeGlobalContextProperty: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getInternalContext: any;

  constructor() {
    this.initialized = false;
  }

  _initializeLogger({ env, service }: types.LoggerConfig): void {
    try {
      datadogLogs.init({
        clientToken: DATADOG_LOG_CLIENT_TOKEN,
        site: "datadoghq.com",
        service,
        env,
        version: gitSha,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
      });

      this.setUser = datadogLogs.setUser;
      this.setGlobalContextProperty = datadogLogs.setGlobalContextProperty;
      this.removeGlobalContextProperty =
        datadogLogs.removeGlobalContextProperty;
      this.getInternalContext = datadogLogs.getInternalContext;
      this.initialized = true;
    } catch (err) {
      /**
       * Disabling because native console.error will be used to
       * notify if Logger fails to initialize
       */
      /* eslint-disable-next-line */
      console.error("[Logger]::Failed to initialize.");
    }
  }

  _warnNoLogger(): void {
    /**
     * Disabling because native console.warn will be used to
     * notify if Logger fails to initialize
     */
    /* eslint-disable-next-line */
    console.warn("[Logger]::Not initialized.");
  }

  error(message: string, payload?: object, error?: Error): void {
    this.initialized
      ? datadogLogs.logger.error(message, payload, error)
      : this._warnNoLogger();
  }

  info(message: string, payload?: object, error?: Error): void {
    this.initialized
      ? datadogLogs.logger.info(message, payload, error)
      : this._warnNoLogger();
  }

  warn(message: string, payload?: object, error?: Error): void {
    this.initialized
      ? datadogLogs.logger.warn(message, payload, error)
      : this._warnNoLogger();
  }
}

export default new Logger();
